<template>
  <div>

      <Container :info="pageInfo">
          <cardBox :info="pageInfo" :activity="activityInfo" />
      </Container>
    <!-- <CardLoding :info="pageInfo" :activity="activityInfo" /> -->
    <Container :info="pageInfo">
        <cardExtractBtnBox :info="pageInfo" :activity="activityInfo" />
        <shareBtn :info="pageInfo" :activity="activityInfo" />
    </Container>
    <exchangeBox :info="{}" :activity="activityInfo" />
    <prizeList :info="pageInfo" :activity="activityInfo" />
    
  </div>
</template>

<script>
export default {
  name: "preview",
  data() {
    return {
      pageInfo: {
          img: 'https://static.enmonster.com/1372827904635092992'
      }, // 页面配置
      activityInfo: {
          activityStatus: 2
      }, // 活动信息配置
      activityId: '' , // 活动id
    };
  },
  mounted() {
    
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
</style>